/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CustomField } from '../../../shared/model/customfieldsresponse';
import { ZsdFormIOComponent } from '../zsdformio/zsdformio.component';
import { QuickCallDetailInfo } from '../model/quickcallresponse';


@Component({
    selector: 'zsd-quickcallfields',
    templateUrl: '../view/quickcallfields.component.html',
    styleUrls: ['../view/quickcallfields.component.scss']
  })
  export class QuickcallFieldsComponent implements OnInit {

    @Input('parentForm') public parentForm: FormGroup;
    @Input('customFields') public customFields: (CustomField[] | null);
    @Input('id') public id: number;
    quickcallFieldsForm: FormGroup;
    @Input('formSchema') public formSchema: [];
    @Input('quickCall') public quickCall: QuickCallDetailInfo ;
    @ViewChild(ZsdFormIOComponent, { static: false }) formio;

    constructor(public formBuilder: FormBuilder) {

    }

    ngOnInit() {
      this.quickcallFieldsForm = this.formBuilder.group({

      });
      if (this.parentForm) {
        this.parentForm.addControl('qc' + this.id + '', this.quickcallFieldsForm);
    }
      this.parentForm.setControl('qc' + this.id + '', this.quickcallFieldsForm);

    }

    public checkSubmit(quickCall: number[]) {
      this.formio.checkSubmitForGroup(quickCall);
    }
  }
